module.exports = __webpack_public_path__ + "img/Kuehtai.691af75a.jpg";